// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__31Hh8","imageUploader":"EGiftCard_imageUploader__JmZMF"};